import { memo, useEffect, useState } from "react";
import { TemplatePage } from "../../2_ksbHub/0_TemplatePage/TemplatePage";

import { useAppContext } from "../../2_ksbHub/context/appContext";
import { EventContext } from "./context/eventContext";

import LoadingAppScreen from "./components/screens/LoadingAppScreen";

import useEventState from "./hooks/useEventState";
import useEventSocket from "./hooks/useEventSocket";
import useEventLoading from "./hooks/useEventLoading";

import { isEventAdmin } from "./utils/eventPermissions";
import EventManagerBody from "./components/EventManagerBody";
import appService from "../../2_ksbHub/service/app.service";

function EventManager() {
  const { currentUser, isAnAdmin } = useAppContext();

  // ✅ state
  const eventState = useEventState();

  const {
    setSchoolyears,
    setSelectedSchoolyear,
    selectedSchoolyearIdRef,

    setEvents,
    selectedEvent,
    setSelectedEvent,
    selectedEventIdRef,

    setShifts,
    setAngebote,

    loadSommerData,
  } = eventState;

  /**
   * ✅ PERMISSIONS
   */
  const isAnEventManagerAdmin = isEventAdmin(
    currentUser,
    isAnAdmin,
    selectedEvent,
  );

  // ✅ socket
  useEventSocket({
    setSchoolyears,
    setSelectedSchoolyear,
    selectedSchoolyearIdRef,

    setEvents,
    setSelectedEvent,
    selectedEventIdRef,

    loadSommerData,
    setShifts,
    setAngebote,
  });

  // ✅ loading
  const { showLoading } = useEventLoading(selectedEvent);

  //for header

  const [users, setUsers] = useState([]);

  useEffect(() => {
    const loadUsers = async () => {
      const data = await appService.getUsers();
      setUsers(data);
    };
    loadUsers();
  }, []);

  return (
    <EventContext.Provider
      value={{
        ...eventState,
        isAnEventManagerAdmin,
      }}
    >
      <TemplatePage
        type="eventManagerApp"
        admins={selectedEvent?.admins}
        users={users}
      >
        {showLoading ? <LoadingAppScreen /> : <EventManagerBody />}
      </TemplatePage>
    </EventContext.Provider>
  );
}

export default memo(EventManager);
